import { render, staticRenderFns } from "./SendVerifyEmail.vue?vue&type=template&id=39775dc0&scoped=true&"
import script from "./SendVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./SendVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./SendVerifyEmail.vue?vue&type=style&index=0&id=39775dc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39775dc0",
  null
  
)

export default component.exports